import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface WorkPlaceState {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: WorkPlaceState = {
  data: [],
  isLoading: false,
  error: null,
};

const workPlaceSlice = createSlice({
  name: 'workPlace',
  initialState,
  reducers: {
    setWorkPlaces: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setWorkPlaceLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setWorkPlaceError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setWorkPlaces, setWorkPlaceLoading, setWorkPlaceError } = workPlaceSlice.actions;

export default workPlaceSlice.reducer;
